<template>
  <div class="socket-error" v-if="displaySocketError">
    <div class="horizontal layout center center-justified content-error-socket">
      {{ $t("webSocketAlert") }}
      {{ $t("connectionLost") }}
      <a
        class="underline cursor-pointer text-base-0"
        @click="reloadPage"
      >
        {{ $t("reloadTextLink") }}
      </a>
    </div>
  </div>
</template>
<script>
import Util from '@/util'

export default {
  computed: {
    displaySocketError() {
      // only show error for users who were never able to connect to socket from the beginning
      return !this.$store.state.socketId
    },
  },
  methods: {
    reloadPage() {
      Util.mixpanelTracking('Presentation Editor', 'No Websocket > Click Reload', 'Reload page')
      window.location.reload()
    },
  },
}
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
@import "@/assets/scss/mixins.scss";

.socket-error {
  @apply bg-red-100;
  padding: 16px;
  color: #fff;
  font-size: 14px;
  line-height: 1.2;

  .content-error-socket {
    max-width: 1024px;
    margin: 0 auto;
  }

  @media (max-width: 560px) {
    padding: 8px;
  }
}
</style>
